export default {"src":"/_next/static/media/GOLF.18f3f17b.svg","height":18,"width":18};